<template>
  <section class="admin-content">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ─────────────────────────────────────── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0;">
            <div class="header-icon-wrap mr-3">
              <i class="fe fe-user-plus" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Add Employee</h4>
              <small style="opacity: 0.8;">Register a new agency user</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">
        <form @submit.prevent="registerUser">

          <!-- ── 1. Personal Information ─────────────────────── -->
          <div class="card shadow-sm form-card mb-4">
            <div class="form-card-header">
              <div class="section-number">1</div>
              <h6 class="mb-0 font-weight-bold text-white">Personal Information</h6>
            </div>
            <div class="card-body px-4 pt-4 pb-3">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">First Name</label>
                  <input type="text" class="form-control" v-model="register.firstname" placeholder="First Name" />
                </div>
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">Last Name</label>
                  <input type="text" class="form-control" v-model="register.lastname" placeholder="Last Name" />
                </div>
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">Email</label>
                  <input type="email" class="form-control" v-model="register.email" placeholder="Email" />
                </div>
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">Phone Number</label>
                  <input v-phone type="text" class="form-control" v-model="register.phone_number" placeholder="Phone Number" />
                </div>
              </div>
            </div>
          </div>

          <!-- ── 2. Location ─────────────────────────────────── -->
          <div class="card shadow-sm form-card mb-4">
            <div class="form-card-header">
              <div class="section-number">2</div>
              <h6 class="mb-0 font-weight-bold text-white">Location</h6>
            </div>
            <div class="card-body px-4 pt-4 pb-3">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">LGA</label>
                  <select class="form-control" v-model="register.localgovt" @change="fetchWards($event)">
                    <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">
                      {{ lga.local_name }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">Ward</label>
                  <select class="form-control" v-model="register.ward" @change="getProvidersByWards($event)">
                    <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">
                      {{ ward.ward_name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- ── 3. Role & Access ────────────────────────────── -->
          <div class="card shadow-sm form-card mb-4">
            <div class="form-card-header">
              <div class="section-number">3</div>
              <h6 class="mb-0 font-weight-bold text-white">Role &amp; Access</h6>
            </div>
            <div class="card-body px-4 pt-4 pb-3">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">Job Title/Department</label>
                  <select class="form-control" v-model="register.job_title">
                    <option value="Executive Secretary">Executive Secretary</option>
                    <option value="Claims Vetter">Claims Vetter</option>
                    <option value="Claims Verifier">Claims Verifier</option>
                    <option value="Enrollment Officer">Enrollment Officer</option>
                    <option value="M and E">M and E</option>
                    <option value="Finance">Finance</option>
                    <option value="Inter-state">Inter-state (Desk Officer) </option>
                    <option value="marketer">Marketer</option>
                    <option value="dashboard">Dashboard (view only)</option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">Role</label>
                  <select class="form-control" v-model="register.role">
                    <option :value="admin_role">Admin</option>
                    <option :value="user_role">Maintainer</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- ── Default password notice ────────────────────── -->
          <div class="alert alert-notice d-flex align-items-center mb-4">
            <i class="fe fe-info mr-3" style="font-size: 1.1rem; flex-shrink: 0;"></i>
            <span>
              The default password for all new employees is <strong>'euhler'</strong>.
              Ask them to change it after their first login.
            </span>
          </div>

          <!-- ── Submit ─────────────────────────────────────── -->
          <div class="card shadow-sm border-0 form-card">
            <div class="card-body px-4 py-3 d-flex justify-content-end" style="gap: 10px;">
              <button type="button" class="btn btn-outline-secondary px-4" @click="$router.go(-1)">
                Cancel
              </button>
              <button type="submit" class="btn btn-submit px-5">
                <i class="fe fe-send mr-2"></i> Add Employee
              </button>
            </div>
          </div>

        </form>
      </div>

      <div class="vld-parent">
        <loading
          :active.sync="isLoading"
          loader="dots"
          :can-cancel="true"
          :is-full-page="fullPage"
        ></loading>
      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      states: "",
      employees: "",
      state: "",
      lga_states: "",
      wards: "",
      admin_role: 1,
      user_role: 0,
      register: {
        firstname: "",
        lastname: "",
        email: "",
        phone_number: "",
        type: "employee",
        state: "",
        institutional_id: "",
        job_title: "",
        lga: "",
        id_card_number: "",
        ward: "",
        address: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/getEmployee/90`)
      .then((response) => {
        this.employees = response.data.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    getEmployees() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getEmployee/90`)
        .then((response) => {
          this.employees = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    fetchWards() {
      this.axios
        .get(`/api/v1/auth/getwards/${event.target.value}`)
        .then((response) => {
          this.wards = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    fetchLga() {
      this.axios
        .get(`/api/v1/auth/lga/2669`)
        .then((response) => {
          this.lga_states = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    registerUser() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/registerProvider", {
          firstname: this.register.firstname,
          lastname: this.register.lastname,
          email: this.register.email,
          phone_number: this.register.phone_number,
          type: this.register.type,
          password: "euhler",
          state: "2669",
          enrolled_by: 0,
          localgovt: this.register.localgovt,
          ward: this.register.ward,
          id_card_number: this.register.id_card_number,
          institutional_id: 90,
          job_title: this.register.job_title,
          user_role: this.register.role,
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.register = {};

          this.$toasted.info("Employee added Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.$toasted.info("Employee Password is 'euhler' ", {
            position: "top-center",
            duration: 3000,
          });
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
          this.$toasted.error("Error ", {
            position: "top-center",
            duration: 3000,
          });
        });
    },
  },
  created() {
    this.fetchLga();
  },
};
</script>

<style scoped>
  /* ── Page Header ─────────────────────────────────────── */
  .page-header {
    background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
    padding-bottom: 60px;
  }

  .header-icon-wrap {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.18);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  /* ── Form Cards ──────────────────────────────────────── */
  .form-card {
    border-radius: 14px;
    border: none;
    overflow: hidden;
  }

  .form-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    background: linear-gradient(135deg, #1e3a5f, #2563eb);
  }

  .section-number {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.25);
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  /* ── Submit Button ───────────────────────────────────── */
  .btn-submit {
    background: linear-gradient(135deg, #2563eb, #7c3aed);
    color: #fff;
    border: none;
    border-radius: 8px;
    font-weight: 600;
  }

  .btn-submit:hover {
    opacity: 0.92;
    color: #fff;
  }

  /* ── Notice alert ────────────────────────────────────── */
  .alert-notice {
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    color: #1e40af;
    border-radius: 10px;
    font-size: 0.88rem;
  }

  /* ── Form controls ───────────────────────────────────── */
  .form-control:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 0.15rem rgba(37, 99, 235, 0.2);
  }
</style>
